import { render, staticRenderFns } from "./ExpandIcon.vue?vue&type=template&id=a0037ab0&scoped=true&"
import script from "./ExpandIcon.vue?vue&type=script&lang=js&"
export * from "./ExpandIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExpandIcon.vue?vue&type=style&index=0&id=a0037ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0037ab0",
  null
  
)

export default component.exports